import { c as create_ssr_component, b as add_attribute, v as validate_component } from "./ssr.js";
import { c as classNames } from "./util.js";
const STYLE_SHARED = "m-0 p-0 disabled:cursor-not-allowed disabled:opacity-50 rounded-full cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 font-sans no-underline text-center";
const BaseButton = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let className;
  let { styles } = $$props;
  let { size = "default" } = $$props;
  let { type = "button" } = $$props;
  let { href = void 0 } = $$props;
  let { disabled = false } = $$props;
  const STYLE_SIZES = {
    sm: `px-4 py-2 text-sm sm:text-base sm:px-4 sm:py-1`,
    default: `px-4 py-2 text-base sm:text-lg sm:px-5 sm:py-3`,
    lg: `px-8 sm:px-12 py-3 text-base sm:py-4 sm:text-xl`
  };
  if ($$props.styles === void 0 && $$bindings.styles && styles !== void 0)
    $$bindings.styles(styles);
  if ($$props.size === void 0 && $$bindings.size && size !== void 0)
    $$bindings.size(size);
  if ($$props.type === void 0 && $$bindings.type && type !== void 0)
    $$bindings.type(type);
  if ($$props.href === void 0 && $$bindings.href && href !== void 0)
    $$bindings.href(href);
  if ($$props.disabled === void 0 && $$bindings.disabled && disabled !== void 0)
    $$bindings.disabled(disabled);
  className = classNames(styles, STYLE_SHARED, STYLE_SIZES[size], disabled ? "disabled" : "");
  return `${href ? `<a${add_attribute("href", href, 0)}${add_attribute("class", className, 0)} ${disabled ? "disabled" : ""}>${slots.default ? slots.default({}) : ``}</a>` : `<button${add_attribute("type", type, 0)}${add_attribute("class", className, 0)} ${disabled ? "disabled" : ""}>${slots.default ? slots.default({}) : ``}</button>`}`;
});
const PrimaryButton = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let { disabled = void 0 } = $$props;
  let { type = "button" } = $$props;
  let { size = void 0 } = $$props;
  let { href = void 0 } = $$props;
  if ($$props.disabled === void 0 && $$bindings.disabled && disabled !== void 0)
    $$bindings.disabled(disabled);
  if ($$props.type === void 0 && $$bindings.type && type !== void 0)
    $$bindings.type(type);
  if ($$props.size === void 0 && $$bindings.size && size !== void 0)
    $$bindings.size(size);
  if ($$props.href === void 0 && $$bindings.href && href !== void 0)
    $$bindings.href(href);
  return `${validate_component(BaseButton, "BaseButton").$$render(
    $$result,
    {
      type,
      size,
      disabled,
      href,
      styles: "font-medium bg-black focus:ring-black border-2 border-transparent text-white"
    },
    {},
    {
      default: () => {
        return `${slots.default ? slots.default({}) : ``}`;
      }
    }
  )}`;
});
export {
  BaseButton as B,
  PrimaryButton as P
};
